import IosPaywallPage from '@/views/profile/IosPaywallPage'

export default function IosPaywallScreen() {
  return <IosPaywallPage />
}
